var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#EB0728"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5833 25.4785L19.1042 19.9993C18.6875 20.3605 18.2017 20.6417 17.6467 20.8431C17.0917 21.0445 16.5011 21.1452 15.875 21.1452C14.3728 21.1452 13.1014 20.6243 12.0608 19.5827C11.0203 18.541 10.5 17.2841 10.5 15.8118C10.5 14.3396 11.0208 13.0827 12.0625 12.041C13.1042 10.9993 14.3646 10.4785 15.8438 10.4785C17.3229 10.4785 18.5799 10.9993 19.6146 12.041C20.6493 13.0827 21.1667 14.3407 21.1667 15.815C21.1667 16.4101 21.0694 16.9855 20.875 17.541C20.6806 18.0966 20.3889 18.6174 20 19.1035L25.5 24.5618L24.5833 25.4785ZM15.8542 19.8952C16.9826 19.8952 17.9418 19.4959 18.7318 18.6973C19.5217 17.8987 19.9167 16.9368 19.9167 15.8118C19.9167 14.6868 19.5217 13.725 18.7318 12.9264C17.9418 12.1278 16.9826 11.7285 15.8542 11.7285C14.7141 11.7285 13.7451 12.1278 12.947 12.9264C12.149 13.725 11.75 14.6868 11.75 15.8118C11.75 16.9368 12.149 17.8987 12.947 18.6973C13.7451 19.4959 14.7141 19.8952 15.8542 19.8952Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.57c2761023e931ef2c03160b56344de2.svg";
export { ForwardRef as ReactComponent };